import { TipAllocationModeEnum } from '@/gen/cortado/v1/settings_pb'

/** Maps UNSPECIFIED/undefined (never-set or pre-feature data) to LAST_SCHEDULE. */
export function normalizeTipAllocationMode(value?: TipAllocationModeEnum): TipAllocationModeEnum {
  return value === TipAllocationModeEnum.TIP_ALLOCATION_MODE_PRO_RATA
    ? TipAllocationModeEnum.TIP_ALLOCATION_MODE_PRO_RATA
    : TipAllocationModeEnum.TIP_ALLOCATION_MODE_LAST_SCHEDULE
}
